import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { post } from "../../lib/request"

/**
 * POST /api/v1/clients/:clientId/posts/regenerate
 * Body: JSON array of content topic post ids, e.g. [2213, 2345]
 */
export const regenerateClientPostsCaptions = createAsyncThunk(
  "postsRegenerate/regenerateClientPostsCaptions",
  async ({ clientId, postIds }, { rejectWithValue }) => {
    try {
      if (clientId == null || clientId === "") {
        return rejectWithValue("Missing client id")
      }
      const ids = (Array.isArray(postIds) ? postIds : [])
        .map((n) => Number(n))
        .filter((n) => !Number.isNaN(n))
      if (ids.length === 0) {
        return rejectWithValue("No post ids to regenerate")
      }
      const data = await post(`posts/clients/${clientId}/regenerate`, ids)
      return data
    } catch (err) {
      return rejectWithValue(err?.message || "Regenerate failed")
    }
  },
)

const initialState = {
  status: "idle",
  error: null,
  lastResponse: null,
}

const postsRegenerateSlice = createSlice({
  name: "postsRegenerate",
  initialState,
  reducers: {
    clearPostsRegenerate: (state) => {
      state.status = "idle"
      state.error = null
      state.lastResponse = null
    },
    clearPostsRegenerateError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(regenerateClientPostsCaptions.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(regenerateClientPostsCaptions.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.lastResponse = action.payload
      })
      .addCase(regenerateClientPostsCaptions.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { clearPostsRegenerate, clearPostsRegenerateError } = postsRegenerateSlice.actions
export default postsRegenerateSlice.reducer
